import { forwardRef } from 'react';

export const TwoBuildingsIcon = forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>(
  function Icon(props, ref) {
    return (
      <svg ref={ref} viewBox="0 0 42 42" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.202148 40.4461C0.202148 40.1115 0.473361 39.8403 0.807918 39.8403H41.1925C41.5271 39.8403 41.7983 40.1115 41.7983 40.4461C41.7983 40.7807 41.5271 41.0519 41.1925 41.0519H0.807918C0.473361 41.0519 0.202148 40.7807 0.202148 40.4461Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.7872 2.37846C24.9015 2.49216 24.9658 2.64671 24.9658 2.80792V35.8223C24.9658 35.9835 24.9016 36.138 24.7873 36.2517C24.6731 36.3654 24.5183 36.4289 24.3571 36.4281L4.92807 36.3352C4.59465 36.3336 4.3252 36.0629 4.3252 35.7295V2.90888C4.3252 2.57555 4.59449 2.30485 4.92782 2.30312L24.3569 2.20216C24.5181 2.20132 24.6729 2.26477 24.7872 2.37846ZM5.53673 3.51151V35.1266L23.7542 35.2137V3.41684L5.53673 3.51151Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.5853 21.2837C10.9198 21.2837 11.191 21.5549 11.191 21.8895V24.0177C11.191 24.3523 10.9198 24.6235 10.5853 24.6235C10.2507 24.6235 9.97949 24.3523 9.97949 24.0177V21.8895C9.97949 21.5549 10.2507 21.2837 10.5853 21.2837Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.4119 21.2837C13.7465 21.2837 14.0177 21.5549 14.0177 21.8895V24.0177C14.0177 24.3523 13.7465 24.6235 13.4119 24.6235C13.0774 24.6235 12.8062 24.3523 12.8062 24.0177V21.8895C12.8062 21.5549 13.0774 21.2837 13.4119 21.2837Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.2391 21.2837C16.5736 21.2837 16.8448 21.5549 16.8448 21.8895V24.0177C16.8448 24.3523 16.5736 24.6235 16.2391 24.6235C15.9045 24.6235 15.6333 24.3523 15.6333 24.0177V21.8895C15.6333 21.5549 15.9045 21.2837 16.2391 21.2837Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.0657 21.2837C19.4003 21.2837 19.6715 21.5549 19.6715 21.8895V24.0177C19.6715 24.3523 19.4003 24.6235 19.0657 24.6235C18.7312 24.6235 18.46 24.3523 18.46 24.0177V21.8895C18.46 21.5549 18.7312 21.2837 19.0657 21.2837Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.5853 25.3223C10.9198 25.3223 11.191 25.5935 11.191 25.928V28.0563C11.191 28.3909 10.9198 28.6621 10.5853 28.6621C10.2507 28.6621 9.97949 28.3909 9.97949 28.0563V25.928C9.97949 25.5935 10.2507 25.3223 10.5853 25.3223Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.4119 25.3223C13.7465 25.3223 14.0177 25.5935 14.0177 25.928V28.0563C14.0177 28.3909 13.7465 28.6621 13.4119 28.6621C13.0774 28.6621 12.8062 28.3909 12.8062 28.0563V25.928C12.8062 25.5935 13.0774 25.3223 13.4119 25.3223Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.0657 25.3223C19.4003 25.3223 19.6715 25.5935 19.6715 25.928V28.0563C19.6715 28.3909 19.4003 28.6621 19.0657 28.6621C18.7312 28.6621 18.46 28.3909 18.46 28.0563V25.928C18.46 25.5935 18.7312 25.3223 19.0657 25.3223Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.8929 25.3223C22.2274 25.3223 22.4986 25.5935 22.4986 25.928V28.0563C22.4986 28.3909 22.2274 28.6621 21.8929 28.6621C21.5583 28.6621 21.2871 28.3909 21.2871 28.0563V25.928C21.2871 25.5935 21.5583 25.3223 21.8929 25.3223Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.5853 29.3608C10.9198 29.3608 11.191 29.6321 11.191 29.9666V32.0949C11.191 32.4294 10.9198 32.7006 10.5853 32.7006C10.2507 32.7006 9.97949 32.4294 9.97949 32.0949V29.9666C9.97949 29.6321 10.2507 29.3608 10.5853 29.3608Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.4119 29.3608C13.7465 29.3608 14.0177 29.6321 14.0177 29.9666V32.0949C14.0177 32.4294 13.7465 32.7006 13.4119 32.7006C13.0774 32.7006 12.8062 32.4294 12.8062 32.0949V29.9666C12.8062 29.6321 13.0774 29.3608 13.4119 29.3608Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.2391 29.3608C16.5736 29.3608 16.8448 29.6321 16.8448 29.9666V32.0949C16.8448 32.4294 16.5736 32.7006 16.2391 32.7006C15.9045 32.7006 15.6333 32.4294 15.6333 32.0949V29.9666C15.6333 29.6321 15.9045 29.3608 16.2391 29.3608Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.0657 29.3608C19.4003 29.3608 19.6715 29.6321 19.6715 29.9666V32.0949C19.6715 32.4294 19.4003 32.7006 19.0657 32.7006C18.7312 32.7006 18.46 32.4294 18.46 32.0949V29.9666C18.46 29.6321 18.7312 29.3608 19.0657 29.3608Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.8929 29.3608C22.2274 29.3608 22.4986 29.6321 22.4986 29.9666V32.0949C22.4986 32.4294 22.2274 32.7006 21.8929 32.7006C21.5583 32.7006 21.2871 32.4294 21.2871 32.0949V29.9666C21.2871 29.6321 21.5583 29.3608 21.8929 29.3608Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.5853 5.12988C10.9198 5.12988 11.191 5.40109 11.191 5.73565V7.86392C11.191 8.19848 10.9198 8.46969 10.5853 8.46969C10.2507 8.46969 9.97949 8.19848 9.97949 7.86392V5.73565C9.97949 5.40109 10.2507 5.12988 10.5853 5.12988Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.4119 5.12988C13.7465 5.12988 14.0177 5.40109 14.0177 5.73565V7.86392C14.0177 8.19848 13.7465 8.46969 13.4119 8.46969C13.0774 8.46969 12.8062 8.19848 12.8062 7.86392V5.73565C12.8062 5.40109 13.0774 5.12988 13.4119 5.12988Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.2391 5.12988C16.5736 5.12988 16.8448 5.40109 16.8448 5.73565V7.86392C16.8448 8.19848 16.5736 8.46969 16.2391 8.46969C15.9045 8.46969 15.6333 8.19848 15.6333 7.86392V5.73565C15.6333 5.40109 15.9045 5.12988 16.2391 5.12988Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.0657 5.12988C19.4003 5.12988 19.6715 5.40109 19.6715 5.73565V7.86392C19.6715 8.19848 19.4003 8.46969 19.0657 8.46969C18.7312 8.46969 18.46 8.19848 18.46 7.86392V5.73565C18.46 5.40109 18.7312 5.12988 19.0657 5.12988Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.0657 13.207C19.4003 13.207 19.6715 13.4782 19.6715 13.8128V15.9411C19.6715 16.2756 19.4003 16.5468 19.0657 16.5468C18.7312 16.5468 18.46 16.2756 18.46 15.9411V13.8128C18.46 13.4782 18.7312 13.207 19.0657 13.207Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.8929 5.12988C22.2274 5.12988 22.4986 5.40109 22.4986 5.73565V7.86392C22.4986 8.19848 22.2274 8.46969 21.8929 8.46969C21.5583 8.46969 21.2871 8.19848 21.2871 7.86392V5.73565C21.2871 5.40109 21.5583 5.12988 21.8929 5.12988Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.4119 17.2456C13.7465 17.2456 14.0177 17.5168 14.0177 17.8514V19.9796C14.0177 20.3142 13.7465 20.5854 13.4119 20.5854C13.0774 20.5854 12.8062 20.3142 12.8062 19.9796V17.8514C12.8062 17.5168 13.0774 17.2456 13.4119 17.2456Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.2391 17.2456C16.5736 17.2456 16.8448 17.5168 16.8448 17.8514V19.9796C16.8448 20.3142 16.5736 20.5854 16.2391 20.5854C15.9045 20.5854 15.6333 20.3142 15.6333 19.9796V17.8514C15.6333 17.5168 15.9045 17.2456 16.2391 17.2456Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.8929 17.2456C22.2274 17.2456 22.4986 17.5168 22.4986 17.8514V19.9796C22.4986 20.3142 22.2274 20.5854 21.8929 20.5854C21.5583 20.5854 21.2871 20.3142 21.2871 19.9796V17.8514C21.2871 17.5168 21.5583 17.2456 21.8929 17.2456Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.4119 9.16846C13.7465 9.16846 14.0177 9.43967 14.0177 9.77423V11.9025C14.0177 12.2371 13.7465 12.5083 13.4119 12.5083C13.0774 12.5083 12.8062 12.2371 12.8062 11.9025V9.77423C12.8062 9.43967 13.0774 9.16846 13.4119 9.16846Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.2391 9.16846C16.5736 9.16846 16.8448 9.43967 16.8448 9.77423V11.9025C16.8448 12.2371 16.5736 12.5083 16.2391 12.5083C15.9045 12.5083 15.6333 12.2371 15.6333 11.9025V9.77423C15.6333 9.43967 15.9045 9.16846 16.2391 9.16846Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.8929 9.16846C22.2274 9.16846 22.4986 9.43967 22.4986 9.77423V11.9025C22.4986 12.2371 22.2274 12.5083 21.8929 12.5083C21.5583 12.5083 21.2871 12.2371 21.2871 11.9025V9.77423C21.2871 9.43967 21.5583 9.16846 21.8929 9.16846Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.5853 13.207C10.9198 13.207 11.191 13.4782 11.191 13.8128V15.9411C11.191 16.2756 10.9198 16.5468 10.5853 16.5468C10.2507 16.5468 9.97949 16.2756 9.97949 15.9411V13.8128C9.97949 13.4782 10.2507 13.207 10.5853 13.207Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.75811 21.2837C8.09267 21.2837 8.36388 21.5549 8.36388 21.8895V24.0177C8.36388 24.3523 8.09267 24.6235 7.75811 24.6235C7.42356 24.6235 7.15234 24.3523 7.15234 24.0177V21.8895C7.15234 21.5549 7.42356 21.2837 7.75811 21.2837Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.75811 25.3223C8.09267 25.3223 8.36388 25.5935 8.36388 25.928V28.0563C8.36388 28.3909 8.09267 28.6621 7.75811 28.6621C7.42356 28.6621 7.15234 28.3909 7.15234 28.0563V25.928C7.15234 25.5935 7.42356 25.3223 7.75811 25.3223Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.75811 29.3608C8.09267 29.3608 8.36388 29.6321 8.36388 29.9666V32.0949C8.36388 32.4294 8.09267 32.7006 7.75811 32.7006C7.42356 32.7006 7.15234 32.4294 7.15234 32.0949V29.9666C7.15234 29.6321 7.42356 29.3608 7.75811 29.3608Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.75811 5.12988C8.09267 5.12988 8.36388 5.40109 8.36388 5.73565V7.86392C8.36388 8.19848 8.09267 8.46969 7.75811 8.46969C7.42356 8.46969 7.15234 8.19848 7.15234 7.86392V5.73565C7.15234 5.40109 7.42356 5.12988 7.75811 5.12988Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.75811 13.207C8.09267 13.207 8.36388 13.4782 8.36388 13.8128V15.9411C8.36388 16.2756 8.09267 16.5468 7.75811 16.5468C7.42356 16.5468 7.15234 16.2756 7.15234 15.9411V13.8128C7.15234 13.4782 7.42356 13.207 7.75811 13.207Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.75811 17.2456C8.09267 17.2456 8.36388 17.5168 8.36388 17.8514V19.9796C8.36388 20.3142 8.09267 20.5854 7.75811 20.5854C7.42356 20.5854 7.15234 20.3142 7.15234 19.9796V17.8514C7.15234 17.5168 7.42356 17.2456 7.75811 17.2456Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.75811 9.16846C8.09267 9.16846 8.36388 9.43967 8.36388 9.77423V11.9025C8.36388 12.2371 8.09267 12.5083 7.75811 12.5083C7.42356 12.5083 7.15234 12.2371 7.15234 11.9025V9.77423C7.15234 9.43967 7.42356 9.16846 7.75811 9.16846Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.2391 13.207C16.5736 13.207 16.8448 13.4782 16.8448 13.8128V15.9411C16.8448 16.2756 16.5736 16.5468 16.2391 16.5468C15.9045 16.5468 15.6333 16.2756 15.6333 15.9411V13.8128C15.6333 13.4782 15.9045 13.207 16.2391 13.207Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M36.902 6.41602C37.017 6.52979 37.0816 6.68479 37.0816 6.84649V35.8225C37.0816 35.9841 37.017 36.139 36.9022 36.2528C36.7874 36.3665 36.6319 36.4297 36.4703 36.4282L26.3297 36.3353C25.9952 36.3322 25.7265 36.0586 25.7295 35.724C25.7326 35.3895 26.0063 35.1208 26.3408 35.1238L35.8701 35.2111V7.45832L26.3413 7.55319C26.0068 7.55652 25.7329 7.28802 25.7295 6.95348C25.7262 6.61894 25.9947 6.34504 26.3292 6.34171L36.4698 6.24075C36.6315 6.23914 36.7871 6.30225 36.902 6.41602Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.3543 21.2837C28.6889 21.2837 28.9601 21.5549 28.9601 21.8895V24.0177C28.9601 24.3523 28.6889 24.6235 28.3543 24.6235C28.0197 24.6235 27.7485 24.3523 27.7485 24.0177V21.8895C27.7485 21.5549 28.0197 21.2837 28.3543 21.2837Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.181 21.2837C31.5155 21.2837 31.7867 21.5549 31.7867 21.8895V24.0177C31.7867 24.3523 31.5155 24.6235 31.181 24.6235C30.8464 24.6235 30.5752 24.3523 30.5752 24.0177V21.8895C30.5752 21.5549 30.8464 21.2837 31.181 21.2837Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.181 25.3223C31.5155 25.3223 31.7867 25.5935 31.7867 25.928V28.0563C31.7867 28.3909 31.5155 28.6621 31.181 28.6621C30.8464 28.6621 30.5752 28.3909 30.5752 28.0563V25.928C30.5752 25.5935 30.8464 25.3223 31.181 25.3223Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M34.0081 25.3223C34.3427 25.3223 34.6139 25.5935 34.6139 25.928V28.0563C34.6139 28.3909 34.3427 28.6621 34.0081 28.6621C33.6736 28.6621 33.4023 28.3909 33.4023 28.0563V25.928C33.4023 25.5935 33.6736 25.3223 34.0081 25.3223Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.3543 29.3608C28.6889 29.3608 28.9601 29.6321 28.9601 29.9666V32.0949C28.9601 32.4294 28.6889 32.7006 28.3543 32.7006C28.0197 32.7006 27.7485 32.4294 27.7485 32.0949V29.9666C27.7485 29.6321 28.0197 29.3608 28.3543 29.3608Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.181 29.3608C31.5155 29.3608 31.7867 29.6321 31.7867 29.9666V32.0949C31.7867 32.4294 31.5155 32.7006 31.181 32.7006C30.8464 32.7006 30.5752 32.4294 30.5752 32.0949V29.9666C30.5752 29.6321 30.8464 29.3608 31.181 29.3608Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M34.0081 29.3608C34.3427 29.3608 34.6139 29.6321 34.6139 29.9666V32.0949C34.6139 32.4294 34.3427 32.7006 34.0081 32.7006C33.6736 32.7006 33.4023 32.4294 33.4023 32.0949V29.9666C33.4023 29.6321 33.6736 29.3608 34.0081 29.3608Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.181 13.207C31.5155 13.207 31.7867 13.4782 31.7867 13.8128V15.9411C31.7867 16.2756 31.5155 16.5468 31.181 16.5468C30.8464 16.5468 30.5752 16.2756 30.5752 15.9411V13.8128C30.5752 13.4782 30.8464 13.207 31.181 13.207Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.3543 17.2456C28.6889 17.2456 28.9601 17.5168 28.9601 17.8514V19.9796C28.9601 20.3142 28.6889 20.5854 28.3543 20.5854C28.0197 20.5854 27.7485 20.3142 27.7485 19.9796V17.8514C27.7485 17.5168 28.0197 17.2456 28.3543 17.2456Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M34.0081 17.2456C34.3427 17.2456 34.6139 17.5168 34.6139 17.8514V19.9796C34.6139 20.3142 34.3427 20.5854 34.0081 20.5854C33.6736 20.5854 33.4023 20.3142 33.4023 19.9796V17.8514C33.4023 17.5168 33.6736 17.2456 34.0081 17.2456Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.3543 9.16846C28.6889 9.16846 28.9601 9.43967 28.9601 9.77423V11.9025C28.9601 12.2371 28.6889 12.5083 28.3543 12.5083C28.0197 12.5083 27.7485 12.2371 27.7485 11.9025V9.77423C27.7485 9.43967 28.0197 9.16846 28.3543 9.16846Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M34.0081 9.16846C34.3427 9.16846 34.6139 9.43967 34.6139 9.77423V11.9025C34.6139 12.2371 34.3427 12.5083 34.0081 12.5083C33.6736 12.5083 33.4023 12.2371 33.4023 11.9025V9.77423C33.4023 9.43967 33.6736 9.16846 34.0081 9.16846Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.3543 13.207C28.6889 13.207 28.9601 13.4782 28.9601 13.8128V15.9411C28.9601 16.2756 28.6889 16.5468 28.3543 16.5468C28.0197 16.5468 27.7485 16.2756 27.7485 15.9411V13.8128C27.7485 13.4782 28.0197 13.207 28.3543 13.207Z"
        />
      </svg>
    );
  },
);
